










import { Component, Vue } from 'vue-property-decorator'
import ViewDialog from '@/components/dialog/viewDialog.vue'
// import * as attApi from '@/api/common/attach'
import { fileServer } from '@/api/common/upload'

@Component({
  components: {
    ViewDialog
  }
})
export default class PdfViewer extends Vue {
  public showDialog: boolean = false
  public loading: boolean = false

  public pdfUrl: string = ''
  public pdfName: string = ''
  public $refs!: {}
  public created() { }
  public mounted() {
    window.eventBus.$on("pdfViewer", (data: { id: number, guid: string, name: string }) => {
      this.showDialog = true
      this.pdfName = data.name
      this.pdfUrl = fileServer(data.id, data.guid, data.guid + '.pdf')
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("pdfViewer")
  }
  public closeDialog() {
    this.showDialog = false
  }

  // public downloadFile() {
  //   attApi.openFile(this.pdfUrl, this.pdfName)
  // }
}
